import React, {useEffect, useState} from 'react';
import cookie from "react-cookies";
import styled from "styled-components";
import {UserContext, UserDispatcherContext} from "@providers/user";
import {saveCookie} from "@baseHelpers/cookie";
import InvestModal from "./invest_modal";
import AlertBg from "@molecules/lotties/alert_bg";
import Icon from "@atoms/icon";
import ButtonTransparent from "@atoms/button.transparent";
import ButtonBase from "@atoms/button.base";
import {isEmpty} from "@helpers/helpers";
import {useWindowSize} from "@helpers/windows.size";
import {handleShowInvestmentModalTrack} from "./investment_tracks";
import AlertIcon from '@icons/alert.svg';
import ChevronDownIcon from '@icons/chevron-down.svg';

var investmentTimeOut = undefined;
const Investment = ({showFixedBell, city_id, page, investModalShow, setInvestModalShow, eventSection, eventView, investmentPageView, investmentPageSection}) => {
    const userContext = React.useContext(UserContext);
    const userDispatcherContext = React.useContext(UserDispatcherContext);
    const windowSize = useWindowSize();
    const [investDrawerShow, setInvestDrawerShow] = useState(false);
    //const [sectionTrack, setSectionTrack] = useState(eventSection);

    useEffect(() => {
        if (process.browser) {
            const checkCookie = cookie.load('investment_modal');
            const isMobile = (window.innerWidth < 768);

            if (isEmpty(checkCookie) && (page !== 'properties-list' || !isMobile)) {
                if (!isEmpty(investmentTimeOut)) {
                    clearTimeout(investmentTimeOut)
                }

                investmentTimeOut = setTimeout(() => {
                    const checkCookie = cookie.load('investment_modal');

                    if (isEmpty(checkCookie)) {
                        setInvestDrawerShow(true);

                        saveCookie('investment_modal', true, 30, 'm');
                    }
                }, 40000);
            }
        }
    }, []);

    const handleShowInvestModal = () => {

        saveCookie('investment_modal', true, 30, 'm');

        userDispatcherContext({
            type: 'MODALITY',
            payload: {
                type: userContext.modality.type,
                page: userContext.modality.page,
                city_id: userContext.modality.city_id,
                city_name: userContext.modality.city_name,
                show_invest: userContext.modality.show_invest,
                show_invest_modal: true,
                isBadeSaba: userContext.modality.isBadeSaba,
                event_section: investmentPageSection,
                event_view: investmentPageView,
                event_position: 'drawer',
            },
        });

        setInvestDrawerShow(false);
    };

    const handleHideInvestModal = () => {
        setInvestModalShow(false);

        userDispatcherContext({
            type: 'MODALITY',
            payload: {
                type: userContext.modality.type,
                page: userContext.modality.page,
                city_id: userContext.modality.city_id,
                city_name: userContext.modality.city_name,
                show_invest: userContext.modality.show_invest,
                show_invest_modal: false,
                isBadeSaba: userContext.modality.isBadeSaba,
            },
        })
    };

    return (
        <div>
            {
                (showFixedBell && userContext.modality.show_invest) ?
                    <Card>
                        {
                            (page === 'properties-list' && windowSize < 992) ?
                                <InvestModalShowButton
                                    color="primary-reverse"
                                    className="js-investment-modal-show d-inline-block d-lg-none rounded-pill"
                                    onClick={handleShowInvestModal}>
                                    <span>ثبت درخواست</span>
                                </InvestModalShowButton>
                                :
                                <InvestButton
                                    className="js-investment-drawer-button"
                                    onClick={handleShowInvestModal} ariaLabel="center icon">
                                    <Icon width={60} height={60}><AlertIcon/></Icon>
                                </InvestButton>
                        }

                        <Drawer className={'js-investment-drawer ' + ((investDrawerShow && city_id !== 207) ? 'show' : '')}>
                            <div className="position-relative text-white">
                                <DrawerToggle onClick={() => setInvestDrawerShow(false)} ariaLabel="center icon">
                                    <Icon width={16} height={16}><ChevronDownIcon/></Icon>
                                </DrawerToggle>

                                <AlertBg width={48} height={48}/>

                                <span className="h4 d-block mt-16">دنبال خرید ملک هستید؟<br/>پیگیریش با ۲نبش</span>

                                <ButtonBase
                                    onClick={handleShowInvestModal}
                                    color="secondary"
                                    size="sm"
                                    className="mt-24">شروع کنید</ButtonBase>
                            </div>
                        </Drawer>
                    </Card>
                    : ''
            }

            <InvestModal
                isBadeSaba={userContext.modality.isBadeSaba}
                is_popup={userContext.modality.is_popup}
                city_id={city_id}
                show={investModalShow}
                setShow={handleHideInvestModal}
                event_section={eventSection}
                event_view={eventView}
                event_position={userContext.modality.event_position}
            />
        </div>
    );
};

export default React.memo(Investment);

// styles
const Card = styled.div`
    .no-search-result-wrapper & {
        display: none !important;
    }
`;

const InvestModalShowButton = styled(ButtonBase)`
    position: fixed;
    left: 50%;
    bottom: 24px;
    z-index: 45;
    transform: translate(-50%, 0);
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        .show-property & {
            display: none !important;
        }
    }
    
    .icons {
        svg {
            g {
                stroke-width: 1.5;
            }
        }
    }
`;

const InvestButton = styled(ButtonTransparent)`
    display: flex;
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 45;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        .show-property &, .properties-lists & {
            display: none !important;
        }
        
        .properties-lists.is-landing & {
            display: flex !important;
        }
    }
`;

const DrawerToggle = styled(ButtonTransparent)`
    position: absolute;
    top: -60px;
    right: -40px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: ${props => props.theme.primary} !important;
    
    svg {
        path,g {
            stroke: #ffffff;
        }
    }
`;

const Drawer = styled.div`
    position: fixed;
    right: 24px;
    bottom: -100%;
    background-color: ${props => props.theme.primary};
    padding: 40px;
    border-radius: 12px 0 0 0;
    text-align: center;
    z-index: 46;
    transition: all .5s ease;
    
    .no-search-result-wrapper & {
        display: none !important;
    }
    
    &.show {
        bottom: 0;
    }
    
    @media (min-width: ${props => props.theme.screenXsMax}) {
        .modal-open & {
             transition: none;
        }
        
        .html-modal-open & {
            transition: none;
        }
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        left: 24px;
        
        .show-property & {
            display: none !important;
        }
    }
`;

const GolbaharAlertBox = styled.div`
    .btn {
        background-color: #fed33c;
        color: #160647;
    }
    
    .yellow-text {
        color: #fed33c;
    }
`;